    angular.module('task-auto-closer', ['core', 'account.settings'])
        .factory('TaskAutocloserSettings', function ($resource) {
            return $resource('/crm/api/task-autocloser', {}, {
                query: {isArray: false}
            });
        })
        .factory('TaskAutocloserDelay', function ($resource) {
            return $resource('/crm/api/task-autocloser-delay');
        })
        .controller('TaskAutoCloserSettingsCtrl', function ($scope, toastr, User, TaskAutocloserDelay, TaskAutocloserSettings) {
            TaskAutocloserSettings.query().$promise.then(function (settings) {
                $scope.autoCloserSettings = settings;
            });

            $scope.statuses = ['DONE_POSITIVE', 'DONE_NEGATIVE'];

            TaskAutocloserDelay.query().$promise.then(function (items) {
                $scope.delays = items;
            });

            User.autocomplete().$promise.then(function (items) {
                $scope.users = items;
            });

            $scope.addOption = function () {
                $scope.autoCloserSettings.options.push({
                    status: 'DONE_POSITIVE',
                    delay: 'MONTH_1',
                    sendEmail: true,
                    addComment: true
                });
            };

            $scope.save = function () {
                TaskAutocloserSettings.save($scope.autoCloserSettings).$promise.then(function (result) {
                    $scope.autoCloserSettings = result;
                    toastr.success("Zapisano zmiany");
                });
            };
        })
        .config(function ($stateProvider) {
            $stateProvider.state('accountSettingsTaskAutoCloser', {
                parent: 'accountSettings',
                url: '/settings/task-auto-closer',
                views: {
                    'settings@^': {
                        templateUrl: 'app/task/auto-closer/settings-auto-closer.tpl.html',
                        controller: 'TaskAutoCloserSettingsCtrl',
                    }
                }
            });
        });
